import { Card, Col, Row, Space, Spin, Statistic } from "antd";
import {
  DatabaseOutlined,
  FileOutlined,
  RobotOutlined,
  TeamOutlined,
} from "@ant-design/icons";

const formatBytes = (bytes) => {
  if (!bytes) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${(bytes / Math.pow(k, i)).toFixed(2)} ${sizes[i]}`;
};

const KpiCard = ({ title, value, icon, color, loading }) => (
  <Card
    style={{ borderTop: `3px solid ${color}` }}
    styles={{ body: { padding: "8px 12px" } }}
  >
    <Spin spinning={loading}>
      <Space align="start" size={8}>
        <div
          style={{
            background: `${color}18`,
            borderRadius: 6,
            padding: "6px 8px",
            color,
            fontSize: 16,
            lineHeight: 1,
          }}
        >
          {icon}
        </div>
        <Statistic
          title={<span style={{ fontSize: 11 }}>{title}</span>}
          value={value}
          valueStyle={{ fontSize: 16, fontWeight: 600 }}
        />
      </Space>
    </Spin>
  </Card>
);

/**
 * KPI summary row for the Organization page: member and robot counts plus
 * MCAP log volume for the organization.
 *
 * @param {number} memberTotal - Total members (from the members page total)
 * @param {number} robotTotal - Total robots (from the robots page total)
 * @param {Object} mcapStats - MCAPStatsResponse from raasdata-service
 * @param {Function} translate - Translation function (i18n key -> string)
 */
export const OrgKpiRow = ({
  memberTotal = 0,
  robotTotal = 0,
  mcapStats = null,
  membersLoading = false,
  robotsLoading = false,
  statsLoading = false,
  translate = (key) => key,
}) => (
  <Row gutter={[16, 16]} className="mb-24">
    <Col xs={12} md={6}>
      <KpiCard
        title={translate("organizations.orgPage.kpiMembers")}
        value={memberTotal}
        icon={<TeamOutlined />}
        color="#1677ff"
        loading={membersLoading}
      />
    </Col>
    <Col xs={12} md={6}>
      <KpiCard
        title={translate("organizations.orgPage.kpiRobots")}
        value={robotTotal}
        icon={<RobotOutlined />}
        color="#52c41a"
        loading={robotsLoading}
      />
    </Col>
    <Col xs={12} md={6}>
      <KpiCard
        title={translate("organizations.orgPage.kpiMcapFiles")}
        value={mcapStats?.total_files ?? 0}
        icon={<FileOutlined />}
        color="#fa8c16"
        loading={statsLoading}
      />
    </Col>
    <Col xs={12} md={6}>
      <KpiCard
        title={translate("organizations.orgPage.kpiLogSize")}
        value={formatBytes(mcapStats?.total_size_bytes)}
        icon={<DatabaseOutlined />}
        color="#722ed1"
        loading={statsLoading}
      />
    </Col>
  </Row>
);
